"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bagging_1 = require("./bagging");
exports.BaggingClassifier = bagging_1.BaggingClassifier;
var forest_1 = require("./forest");
exports.RandomForestClassifier = forest_1.RandomForestClassifier;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2Vuc2VtYmxlL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEscUNBQThDO0FBR2IsNEJBSHhCLDJCQUFpQixDQUd3QjtBQUZsRCxtQ0FBa0Q7QUFFekMsaUNBRkEsK0JBQXNCLENBRUEifQ==